<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Stepper</strong></h4>
      <a href="https://mdbootstrap.com/vue/components/vue-bootstrap-steps-stepper/?utm_source=DemoApp&utm_medium=MDBVuePro" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr />
    <container class="mt-5">
      <h2>Registration form with steps</h2>

      <h2 class="text-center font-weight-bold pt-4 pb-5 mb-5"><strong>Registration form</strong></h2>
      <stepper buttons>
        <step name="Basic Information"
              icon="folder-open-o"
              slot="content">
          <h3 class="font-weight-bold pl-0 my-4"><strong>Basic Information</strong></h3>
          <mdb-input label="Email"/>
          <mdb-input label="Username"/>
          <mdb-input label="Password"/>
          <mdb-input label="Repeat Password"/>
        </step>
        <step name="Personal Data"
              icon="pencil"
              slot="content">
          <h3 class="font-weight-bold pl-0 my-4"><strong>Personal Data</strong></h3>
          <mdb-input label="First Name"/>
          <mdb-input label="Second Name"/>
          <mdb-input label="Surname"/>
          <mdb-textarea label="Address"/>
        </step>
        <step name="Terms and Conditions"
              icon="photo"
              slot="content">
          <h3 class="font-weight-bold pl-0 my-4"><strong>Terms and conditions</strong></h3>
          <mdb-input type="checkbox" id="checkbox1" label="I agree to the terms and conditions" />
          <mdb-input type="checkbox" id="checkbox2" label="I want to receive newsletter" />

        </step>
        <step name="Finish"
              icon="check"
              slot="content">
          <h3 class="font-weight-bold pl-0 my-4"><strong>Finish</strong></h3>
          <h2 class="text-center font-weight-bold my-4">Registration completed!</h2>
        </step>
      </stepper>

      <hr class="my-5"/>
      <h2>Vertical registration form with steps</h2>

      <stepper vertical buttons>
        <step name="Basic Information"
              icon="folder-open-o"
              slot="content">
          <h3 class="font-weight-bold pl-0 my-4"><strong>Basic Information</strong></h3>
          <mdb-input label="Email"/>
          <mdb-input label="Username"/>
          <mdb-input label="Password"/>
          <mdb-input label="Repeat Password"/>
        </step>
        <step name="Personal Data"
              icon="pencil"
              slot="content">
          <h3 class="font-weight-bold pl-0 my-4"><strong>Personal Data</strong></h3>
          <mdb-input label="First Name"/>
          <mdb-input label="Second Name"/>
          <mdb-input label="Surname"/>
          <mdb-textarea label="Address"/>
        </step>
        <step name="Terms and Conditions"
              icon="heart-o"
              slot="content">
          <h3 class="font-weight-bold pl-0 my-4"><strong>Terms and conditions</strong></h3>
          <mdb-input type="checkbox" id="checkbox1" label="I agree to the terms and conditions" />
          <mdb-input type="checkbox" id="checkbox2" label="I want to receive newsletter" />

        </step>
        <step name="Finish"
              icon="check"
              slot="content">
          <h3 class="font-weight-bold pl-0 my-4"><strong>Finish</strong></h3>
          <h2 class="text-center font-weight-bold my-4">Registration completed!</h2>
        </step>
      </stepper>

      <hr class="my-5"/>
      <h2>Steps within form</h2>

      <column xl="6" lg="7" md="10">

        <card>
          <card-body>
            <h2 class="text-center font-weight-bold pt-4 pb-5"><strong>Steps form example</strong></h2>

            <stepper within buttons>
              <step name="Step 1" slot="content">
                <h3 class="font-weight-bold pl-0 my-4"><strong>Step 1</strong></h3>
                <mdb-input label="First Name"/>
                <mdb-input label="Second Name"/>
                <mdb-textarea label="Address"/>
              </step>
              <step name="Step 2" slot="content">
                <h3 class="font-weight-bold pl-0 my-4"><strong>Step 2</strong></h3>
                <mdb-input label="Company Name"/>
                <mdb-input label="Company Addresws"/>
                <mdb-textarea label="Address"/>
              </step>
              <step name="Step 3" slot="content">
                <h3 class="font-weight-bold pl-0 my-4"><strong>Step 3</strong></h3>
              </step>
            </stepper>
          </card-body>
        </card>

      </column>

      <hr class="my-5"/>
      <h2>Horizontal steppers</h2>

      <stepper simpleH>
        <li class="completed" slot="simple">
          <a href="#!">
            <span class="circle">1</span>
            <span class="label">First step</span>
          </a>
        </li>
        <li class="active" slot="simple">
          <a href="#!">
            <span class="circle">2</span>
            <span class="label">Second step</span>
          </a>
        </li>
        <li class="warning" slot="simple">
          <a href="#!">
            <span class="circle"><i class="fa fa-warning"></i></span>
            <span class="label">Third step</span>
          </a>
        </li>
      </stepper>

        <hr class="my-5"/>
        <h2>Vertical steppers</h2>

        <stepper simpleV>
        <li class="completed" slot="simple">
          <a>
            <span class="circle">1</span>
            <span class="label">First step</span>
          </a>
        </li>
        <li class="active" slot="simple">
          <a>
            <span class="circle">2</span>
            <span class="label">Second step</span>
          </a>
            <div class="step-content grey lighten-3">
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Esse cupiditate voluptate facere iusto quaerat vitae excepturi, accusantium ut aliquam repellat atque nesciunt nostrum similique. Inventore nostrum ut, nobis porro sapiente.</p>
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Dolore error excepturi veniam nemo repellendus, distinctio soluta vitae at sit saepe. Optio eaque quia excepturi adipisci pariatur totam, atque odit fugiat.</p>
              <p>Deserunt voluptatem illum quae nisi soluta eum perferendis nesciunt asperiores tempore saepe reiciendis, vero quod a dolor corporis natus qui magni quas fuga rem excepturi laboriosam. Quisquam expedita ab fugiat.</p>
          </div>
        </li>
        <li class="warning" slot="simple">
          <a>
            <span class="circle"><i class="fa fa-warning"></i></span>
            <span class="label">Third step</span>
          </a>
        </li>
        <li slot="simple">
          <a>
            <span class="circle">4</span>
            <span class="label">Fourth step</span>
          </a>
        </li>
      </stepper>
    </container>
  </container>
</template>

<script>
import { Container, Row, Column, Stepper, Step, mdbInput, mdbTextarea, Card, CardBody, Fa } from 'mdbvue';

export default {
  components: {
    Container,
    Row,
    Column,
    Stepper,
    Step,
    mdbInput,
    mdbTextarea,
    Card,
    CardBody,
    Fa
  }
};
</script>

<style>

</style>
